import { apiClient } from "@nabble/sdk";

export { ADMIN_ROLE_ID, COLLABORATOR_ROLE_ID } from "../model/organizationRoles";

export interface Role {
  id: string;
  name: string;
  description: string;
  system: boolean;
  permissions: string[];
  /** People holding it in some organization. */
  users: number;
  /** Holds a permission over the whole suite: only suite administrators may give it. */
  installation: boolean;
}

export interface RoleInput {
  name: string;
  description: string;
  permissions: string[];
}

export function fetchRoles(): Promise<Role[]> {
  return apiClient<Role[]>("/api/admin/roles");
}

export function createRole(body: RoleInput): Promise<{ id: string }> {
  return apiClient<{ id: string }>("/api/admin/roles", { method: "POST", body });
}

export function updateRole(id: string, body: RoleInput): Promise<void> {
  return apiClient<void>(`/api/admin/roles/${id}`, { method: "PUT", body });
}

export function deleteRole(id: string): Promise<void> {
  return apiClient<void>(`/api/admin/roles/${id}`, { method: "DELETE" });
}
